import React, { FC } from 'react'

// Components
import { PaymentMethodItem } from '../PaymentMethodItem/PaymentMethodItem'

// Redux
import { useAppSelector } from '../../../store/hooks'
import { selectProfileData } from '../../../store/user/userSlice'

// Types
import { ISelectedEvent } from '../../../store/events/eventsSlice'
import { IPaymentMethodOptions } from '../../../types/payment'
import { ISelectedCard } from '../../../models/users/user.interface'

interface SelectPaymentMethodProps {
  selectedEvent?: ISelectedEvent
  selectedPaymentMethod: IPaymentMethodOptions | null
  setSelectedPaymentMethod: (card: IPaymentMethodOptions | null) => void
  setSelectedCard: (value: ISelectedCard) => void
  availablePaymentMethods: IPaymentMethodOptions[]
  isTicketPayment: boolean
}

export const SelectPaymentMethod: FC<SelectPaymentMethodProps> = ({
  selectedEvent,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  setSelectedCard,
  availablePaymentMethods,
  isTicketPayment,
}) => {
  const profileData = useAppSelector(selectProfileData)

  return (
    <div className="w-full">
      <div className="allCards">
        <p className="mb-2 text-sm text-black">Select payment method</p>
        <div className="flex flex-wrap justify-between gap-y-2">
          {availablePaymentMethods.includes('credit-card') && (
            <PaymentMethodItem
              type="credit-card"
              title="Pay by credit card now"
              disabled={
                !selectedEvent?.EventPaymentSettings?.allowCreditCardPayment &&
                profileData.id !== selectedEvent?.EventDetails?.owner
              }
              selectedPaymentMethod={selectedPaymentMethod}
              onClick={() => {
                setSelectedPaymentMethod('credit-card')
                if (setSelectedCard) setSelectedCard({ type: 'card', pmId: '', cardNumber: '' })
              }}
            />
          )}
          {availablePaymentMethods.includes('ach') && (
            <PaymentMethodItem
              type="ach"
              title="Pay by debit card or ACH now"
              disabled={
                !selectedEvent?.EventPaymentSettings?.allowACHPayment &&
                profileData.id !== selectedEvent?.EventDetails?.owner
              }
              selectedPaymentMethod={selectedPaymentMethod}
              onClick={() => {
                setSelectedPaymentMethod('ach')
                if (setSelectedCard)
                  setSelectedCard({ type: 'us_bank_account', pmId: '', cardNumber: '' })
              }}
            />
          )}
          {availablePaymentMethods.includes('delayed') && !isTicketPayment && (
            <PaymentMethodItem
              type="delayed"
              title="Pay by credit, debit or ACH later"
              disabled={
                !selectedEvent?.EventPaymentSettings?.allowDelayedPayment &&
                profileData.id !== selectedEvent?.EventDetails?.owner
              }
              selectedPaymentMethod={selectedPaymentMethod}
              onClick={() => {
                setSelectedPaymentMethod('delayed')
                if (setSelectedCard) setSelectedCard({ type: 'cash', pmId: '', cardNumber: '' })
              }}
            />
          )}
          {availablePaymentMethods.includes('cash') && !isTicketPayment && (
            <PaymentMethodItem
              type="cash"
              title="Pay cash or check at show"
              disabled={
                !selectedEvent?.EventPaymentSettings?.allowWithoutPayment &&
                profileData.id !== selectedEvent?.EventDetails?.owner
              }
              selectedPaymentMethod={selectedPaymentMethod}
              onClick={() => {
                setSelectedPaymentMethod('cash')
                if (setSelectedCard) setSelectedCard({ type: 'cash', pmId: '', cardNumber: '' })
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
